import React from "react";
import { Image, Row, Col } from "antd";
import { PATH_LIGURIA_DIGITALE } from "../../path";
import logoLD from "../../styles/images/loghi/ld.png";
import { useSelector } from "react-redux";
import { isMobileMode } from "../../modules/configuration";

export const Contatti = () => {
  const mobileMode = useSelector(isMobileMode);
  return (
    <div className={mobileMode ? "contattiMobile" : "contatti"}>
      <h1>Surgery Tracker - Pagina Contatti</h1>
      <Row>
        <Col span={12}>
          <a href={PATH_LIGURIA_DIGITALE} target="_blank" rel="noopener noreferrer">
            <Image
              id="liguriaDigitale"
              alt="Logo Liguria Digitale"
              src={logoLD}
              preview={false}
            />
          </a>
        </Col>
        <Col span={12} className="infoOspedale">
          <Row>
            <Col span={24}>
              <span>Liguria Digitale</span>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <a href="mailto:surgerytracker@liguriadigitale.it">surgerytracker@liguriadigitale.it</a>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};
